const CallinHistory = [
    {
      "callinID": 4553,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 1,
      "isMissed": 0,
      "initialDT": "2020-12-04 10:17:07",
      "inComeDT": null,
      "dialDT": "2020-12-04 10:17:11",
      "upDT": "2020-12-04 10:17:22",
      "hangupDT": "2020-12-04 10:17:30",
      "uniqueid_10First": "1607048230",
      "destUniqueID_10First": "1607048231",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:08",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:07",
      "waitDay": 0,
      "waitTime": 23,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4528,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 1,
      "isMissed": 0,
      "initialDT": "2020-12-03 17:58:01",
      "inComeDT": null,
      "dialDT": "2020-12-03 17:58:05",
      "upDT": "2020-12-03 17:58:12",
      "hangupDT": "2020-12-03 17:58:16",
      "uniqueid_10First": "1606989484",
      "destUniqueID_10First": "1606989485",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:04",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:03",
      "waitDay": 1,
      "waitTime": 15,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4521,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-03 17:15:22",
      "inComeDT": null,
      "dialDT": "2020-12-03 17:15:27",
      "upDT": "2020-12-03 17:15:38",
      "hangupDT": "2020-12-03 17:16:02",
      "uniqueid_10First": "1606986926",
      "destUniqueID_10First": "1606986927",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:24",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:23",
      "waitDay": 1,
      "waitTime": 40,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4514,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-03 14:43:13",
      "inComeDT": null,
      "dialDT": "2020-12-03 14:43:18",
      "upDT": null,
      "hangupDT": "2020-12-03 14:43:34",
      "uniqueid_10First": "1606977797",
      "destUniqueID_10First": "1606977798",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": null,
      "upAgent": null,
      "pictureUrl": null,
      "cServicePhoneID": 1,
      "soundlen": null,
      "waitDay": 1,
      "waitTime": 21,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": null
    },
    {
      "callinID": 4480,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-02 14:42:51",
      "inComeDT": null,
      "dialDT": "2020-12-02 14:42:54",
      "upDT": "2020-12-02 14:43:03",
      "hangupDT": "2020-12-02 14:43:12",
      "uniqueid_10First": "1606891373",
      "destUniqueID_10First": "1606891374",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:09",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:08",
      "waitDay": 2,
      "waitTime": 21,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4468,
      "fromPhoneNo": "0934256284",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2511065,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-02 10:38:08",
      "inComeDT": null,
      "dialDT": "2020-12-02 10:38:12",
      "upDT": null,
      "hangupDT": "2020-12-02 10:38:20",
      "uniqueid_10First": "1606876691",
      "destUniqueID_10First": "1606876692",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "張小美",
      "phoneTime": null,
      "upAgent": null,
      "pictureUrl": null,
      "cServicePhoneID": 1,
      "soundlen": null,
      "waitDay": 2,
      "waitTime": 12,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": null
    },
    {
      "callinID": 4466,
      "fromPhoneNo": "0934256284",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2511065,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-02 10:25:07",
      "inComeDT": null,
      "dialDT": "2020-12-02 10:25:09",
      "upDT": null,
      "hangupDT": "2020-12-02 10:25:51",
      "uniqueid_10First": "1606875908",
      "destUniqueID_10First": "1606875909",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "張小美",
      "phoneTime": null,
      "upAgent": null,
      "pictureUrl": null,
      "cServicePhoneID": 1,
      "soundlen": null,
      "waitDay": 2,
      "waitTime": 44,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": null
    },
    {
      "callinID": 4465,
      "fromPhoneNo": "0934256284",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2511065,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-02 10:14:01",
      "inComeDT": null,
      "dialDT": "2020-12-02 10:14:04",
      "upDT": "2020-12-02 10:14:32",
      "hangupDT": "2020-12-02 10:14:51",
      "uniqueid_10First": "1606875243",
      "destUniqueID_10First": "1606875243",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "張小美",
      "phoneTime": "00:00:19",
      "upAgent": "55527",
      "pictureUrl": "https://profile.line-scdn.net/0hkfqtaD-lNElMDRm1x2pLHnBIOiQ7IzIBNGgofWBeaSthaiYfdTssJ2pZaXppPyEXcWl6fWoLYytn",
      "cServicePhoneID": 1,
      "soundlen": "00:00:18",
      "waitDay": 2,
      "waitTime": 50,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部Q"
    },
    {
      "callinID": 4449,
      "fromPhoneNo": "0934256284",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2511065,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-01 17:46:06",
      "inComeDT": null,
      "dialDT": "2020-12-01 17:46:10",
      "upDT": "2020-12-01 17:46:42",
      "hangupDT": "2020-12-01 17:46:50",
      "uniqueid_10First": "1606815969",
      "destUniqueID_10First": "1606815970",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "張小美",
      "phoneTime": "00:00:08",
      "upAgent": "55527",
      "pictureUrl": "https://profile.line-scdn.net/0hkfqtaD-lNElMDRm1x2pLHnBIOiQ7IzIBNGgofWBeaSthaiYfdTssJ2pZaXppPyEXcWl6fWoLYytn",
      "cServicePhoneID": 1,
      "soundlen": "00:00:07",
      "waitDay": 3,
      "waitTime": 44,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部Q"
    },
    {
      "callinID": 4434,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-12-01 16:12:17",
      "inComeDT": null,
      "dialDT": "2020-12-01 16:12:21",
      "upDT": "2020-12-01 16:12:31",
      "hangupDT": "2020-12-01 16:12:42",
      "uniqueid_10First": "1606810340",
      "destUniqueID_10First": "1606810341",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:11",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:10",
      "waitDay": 3,
      "waitTime": 25,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4343,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:17:23",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:17:27",
      "upDT": "2020-11-30 12:17:33",
      "hangupDT": "2020-11-30 12:17:45",
      "uniqueid_10First": "1606709846",
      "destUniqueID_10First": "1606709846",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:12",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:11",
      "waitDay": 4,
      "waitTime": 22,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4342,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:16:40",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:16:44",
      "upDT": "2020-11-30 12:16:52",
      "hangupDT": "2020-11-30 12:16:57",
      "uniqueid_10First": "1606709802",
      "destUniqueID_10First": "1606709803",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:05",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:04",
      "waitDay": 4,
      "waitTime": 17,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4341,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:13:15",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:13:19",
      "upDT": null,
      "hangupDT": "2020-11-30 12:13:30",
      "uniqueid_10First": "1606709598",
      "destUniqueID_10First": "1606709599",
      "calledid": "s-toGroup1",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": null,
      "upAgent": null,
      "pictureUrl": null,
      "cServicePhoneID": 1,
      "soundlen": null,
      "waitDay": 4,
      "waitTime": 15,
      "ivrTitle": "#2 白內障或門診",
      "sex": null,
      "age": null,
      "location": null
    },
    {
      "callinID": 4340,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:12:48",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:12:52",
      "upDT": "2020-11-30 12:12:55",
      "hangupDT": "2020-11-30 12:13:03",
      "uniqueid_10First": "1606709571",
      "destUniqueID_10First": "1606709572",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:08",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:07",
      "waitDay": 4,
      "waitTime": 15,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4339,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:07:38",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:07:42",
      "upDT": "2020-11-30 12:07:50",
      "hangupDT": "2020-11-30 12:07:58",
      "uniqueid_10First": "1606709261",
      "destUniqueID_10First": "1606709262",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:08",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:08",
      "waitDay": 4,
      "waitTime": 20,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4337,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:04:16",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:04:20",
      "upDT": "2020-11-30 12:04:24",
      "hangupDT": "2020-11-30 12:04:31",
      "uniqueid_10First": "1606709060",
      "destUniqueID_10First": "1606709060",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:07",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:06",
      "waitDay": 4,
      "waitTime": 15,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4335,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:01:55",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:01:59",
      "upDT": "2020-11-30 12:02:02",
      "hangupDT": "2020-11-30 12:02:06",
      "uniqueid_10First": "1606708918",
      "destUniqueID_10First": "1606708918",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:04",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:03",
      "waitDay": 4,
      "waitTime": 11,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4334,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 12:01:10",
      "inComeDT": null,
      "dialDT": "2020-11-30 12:01:14",
      "upDT": "2020-11-30 12:01:19",
      "hangupDT": "2020-11-30 12:01:25",
      "uniqueid_10First": "1606708873",
      "destUniqueID_10First": "1606708874",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:06",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:05",
      "waitDay": 4,
      "waitTime": 15,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4320,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 09:34:18",
      "inComeDT": null,
      "dialDT": "2020-11-30 09:34:22",
      "upDT": null,
      "hangupDT": "2020-11-30 09:34:31",
      "uniqueid_10First": "1606700061",
      "destUniqueID_10First": "1606700062",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": null,
      "upAgent": null,
      "pictureUrl": null,
      "cServicePhoneID": 1,
      "soundlen": null,
      "waitDay": 4,
      "waitTime": 13,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": null
    },
    {
      "callinID": 4319,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-30 09:33:28",
      "inComeDT": null,
      "dialDT": "2020-11-30 09:33:32",
      "upDT": "2020-11-30 09:33:36",
      "hangupDT": "2020-11-30 09:33:45",
      "uniqueid_10First": "1606700012",
      "destUniqueID_10First": "1606700012",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:09",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:07",
      "waitDay": 4,
      "waitTime": 17,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    },
    {
      "callinID": 4273,
      "fromPhoneNo": "0963356659",
      "displayName": "測試0800",
      "branchName": "測試",
      "cDisplayName": "測試0800",
      "cBranchName": "測試",
      "servicePhoneID": 1,
      "customerID": 2156061,
      "isTransfered": 0,
      "isMissed": 0,
      "initialDT": "2020-11-27 13:54:55",
      "inComeDT": null,
      "dialDT": "2020-11-27 13:54:58",
      "upDT": "2020-11-27 13:55:07",
      "hangupDT": "2020-11-27 13:55:13",
      "uniqueid_10First": "1606456497",
      "destUniqueID_10First": "1606456498",
      "calledid": "s-toGroup0",
      "isCallBack": 0,
      "callBackStatus": null,
      "callFormID": null,
      "isReport": 1,
      "name": "洪逸翔",
      "phoneTime": "00:00:06",
      "upAgent": "55525",
      "pictureUrl": "https://st.depositphotos.com/1779253/5140/v/450/depositphotos_51402587-stock-illustration-female-profile-avatar-icon-dark.jpg",
      "cServicePhoneID": 1,
      "soundlen": "00:00:06",
      "waitDay": 7,
      "waitTime": 18,
      "ivrTitle": "#1 近視雷射",
      "sex": null,
      "age": null,
      "location": "數位發展部J"
    }
  ]
  export default CallinHistory